import React from 'react';
import { useIsOrganizationAdmin } from '../../../../../../hooks/api/useOrganization';
import AdminProfilesRoot from './AdminProfilesRoot';
import AgentProfilesRoot from './AgentProfilesRoot';

export type ProAppProfilesRootOwnProps = {};

export type ProAppProfilesRootProps = ProAppProfilesRootOwnProps;

const ProAppProfilesRoot: React.FC<ProAppProfilesRootProps> = (_props) => {
    const isAdmin = useIsOrganizationAdmin();

    return isAdmin ? <AdminProfilesRoot /> : <AgentProfilesRoot />;
};

export default React.memo(ProAppProfilesRoot);
